import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  HeadingText
} from '@paypalcorp/pp-react';
import styles from './CustomizeTableComponent.module.less';
import MarkdownText from '../../../components/Text/MarkdownText';
import RenderEcmRichText from '../../../components/Text/RenderEcmRichText';

type TableCellData = {
  [key: string]: string;
};
type ContentJson = {
  tableDetails: TableCellData[];
  tableHeaders: string[];
};
type EcmContent = {
  content: string;
  contentJson: ContentJson;
};
type CustomizeTableComponentProps = {
  ecmContent: EcmContent;
};

const CustomizeTableComponent = ({ ecmContent }: CustomizeTableComponentProps) => {
  const { content, contentJson } = ecmContent;
  const { tableDetails, tableHeaders } = contentJson;

  return (
    <div className={styles.container}>
      <RenderEcmRichText content={content} />
      <div className={styles.tableWrapper}>
        <Table isResponsive>
          <TableHead>
            <TableRow>
              {tableHeaders.map((title) => (
                <TableCell key={title} isHeader>
                  <HeadingText size="sm">
                    <MarkdownText text={title} />
                  </HeadingText>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableDetails.map((cell, rowIndex) => (
              <TableRow key={rowIndex}>
                {Object.values(cell).map((value) => (
                  <TableCell className={styles.markdownContent} key={value}>
                    <MarkdownText text={value} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default CustomizeTableComponent;
